import * as types from './actionTypes';
import sketchADaysApi from '../apis/sketchADaysApi';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';

export function loadSketchADaysSuccess(sketchADays) {
    return { type: types.LOAD_SKETCHADAYS_SUCCESS, sketchADays };
}

export function loadSketchADays() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return sketchADaysApi.getAll()
            .then(sketchADays => {
                dispatch(loadSketchADaysSuccess(sketchADays));
            })
            .catch(error => {
                dispatch(ajaxCallError(error));
                throw (error);
            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/sketchADayActions.js